<template>
  <div class="container" style="background: #FFFFFF;">
    <!-- <img src="../../assets/module/1.jpg" /> -->
    <img class="welcome_img" src="../../../assets/images/activity/welcome/1.jpg" />
    <img class="welcome_img" src="../../../assets/images/activity/welcome/2.jpg" />
    <img class="welcome_img" src="../../../assets/images/activity/welcome/3.jpg" />
    <img class="welcome_img" src="../../../assets/images/activity/welcome/4.png" />
    <div class="usernoncardstatusbtnsm" @click="toindex()">查看更多活动</div>
    <div class="welcomediv Anchorlocation" id="anchor">
      <img class="welcome_img" @click="tobuycardempty(1003)" src="../../../assets/images/activity/welcome/6.png" />
      <!-- <div @click="tobuycard(1003)">立即开通</div> -->
      <img class="welcomediv_saleover" src="../../../assets/images/base/saleover.png" />
    </div>
    <!-- <img class="welcome_img Anchorlocation" id="anchor" @click="tobuycard(1003)" src="../../../assets/images/activity/welcome/6.png" /> -->
    <div class="welcomediv">
      <img class="welcome_img" @click="tobuycard(1002)" src="../../../assets/images/activity/welcome/5.png" />
      <div @click="tobuycard(1002)">立即开通</div>
    </div>

    <div class="welcomediv">
      <img class="welcome_img welcome_img2" @click="tobuycard(1001)" src="../../../assets/images/activity/welcome/7.png" />
      <div class="welcomediva" @click="tobuycard(1001)">立即开通</div>
    </div>
    <div class="fx_firstactivityseatasd"></div>
    <!-- <img src="../../assets/module/2.jpg" />
    <img src="../../assets/module/3.jpg" />
    <img src="../../assets/module/4.jpg" /> -->
    <div class="fx_firstactivityseat" v-show="fxfirstactivity"></div>
    <a class="fx_firstactivity" @click="Anchorlocation()" v-show="fxfirstactivity">立即开通</a>
    <div style="position: relative;">
      <img style="width:100%;" src="../../../assets/images/activity/welcome/ddddddddddd.png" />
      <div @click="telasd(400-630-5888)" style="position: absolute;bottom: 0;left: 0;width: 100%;height: 2rem;margin-bottom: 1rem;"></div>
    </div>

    <!-- mask -->
    <div class="welcome_mask" v-show="welcomeMask" @touchmove.prevent @click="hidepanel()"></div>
    <div class="welcome_cont" v-show="welcomeMask" @touchmove.prevent>
      <div class="welcome_cont_panel">
        <div class="welcome_cont_panel_type1" v-show="loginstatus==0">
          <div class="welcome_cont_panel_type1_title">请先验证手机号</div>
          <div class="welcome_cont_panel_type1_panel">
            <label class="welcome_cont_panel_type1_panel_icon"></label>
            <div class="welcome_cont_panel_type1_panel_p">
              <div class="welcome_cont_panel_type1_panel_p_ph">+86</div>
              <div class="welcome_cont_panel_type1_panel_p_on">
                <input type="tel" placeholder="请输入手机号" maxlength="11" v-model="param.mobile" />
              </div>
              <div class="ClearBoth"></div>
            </div>
            <div class="ClearBoth"></div>
          </div>
          <div class="welcome_cont_panel_type1_panel">
            <label class="welcome_cont_panel_type1_panel_iconcode"></label>
            <div class="welcome_cont_panel_type1_panel_q">
              <input type="tel" placeholder="请输入验证码" maxlength="6" v-model="param.sms_code" class="welcome_cont_panel_type1_panel_p_code" />
              <div class="welcome_cont_panel_type1_panel_p_codeSMS" @click.stop.prevent="getSmsCaptcha">{{codeTxt}}</div>
              <div class="ClearBoth"></div>
            </div>
            <div class="ClearBoth"></div>
          </div>
        </div>


        <div class="welcome_cont_panel_type1" v-show="loginstatus==1">
          <div class="welcome_cont_panel_type1_logintitle">尊敬的用户：{{loginedphone}}</div>
        </div>
      </div>

      <div class="welcome_cont_panel">
        <div class="welcome_cont_panel_typec">
          <div class="welcome_cont_panel_type1_title">会员卡类型</div>
          <div class="welcome_cont_panel_type1_tit">
            <img class="welcome_cont_panel_type1_tit_img" v-show="cards_id==1003" src="../../../assets/images/activity/welcome/bkjbz1.png" />
            <img class="welcome_cont_panel_type1_tit_img" v-show="cards_id==1002" src="../../../assets/images/activity/welcome/bkjbz2.png" />
            <img class="welcome_cont_panel_type1_tit_img" v-show="cards_id==1001" src="../../../assets/images/activity/welcome/bkjbz3.png" />
            <img class="welcome_cont_panel_type1_tit_img_saleover" v-show="cards_id==1003" src="../../../assets/images/base/saleover.png" />
          </div>

        </div>
      </div>
      <div class="bb_vip_submit_protol">
        <span v-show="!bgasd" class="bb_vip_submit_protol_bg1" @click="agressno()"></span>
        <span v-show="bgasd" class="bb_vip_submit_protol_bg2" @click="agress()"></span>
        <span class="bb_vip_submit_protol_p">已阅读并同意</span>
        <span class="bb_vip_submit_protol_pro" @click="toprotol()">《斐燃会员开通协议》</span>
      </div>

      <div class="welcome_cont_btn">
        <img class="welcome_cont_btnl" src="../../../assets/images/activity/welcome/buycardl.png" />
        <img class="welcome_cont_btnr" src="../../../assets/images/activity/welcome/buycardr.png" />
        <div class="welcome_cont_price">
          斐燃丨{{cardname}}&nbsp;¥{{peice}}/年
          <div @click="tobCard()">立即开通</div>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
  import {
    isPhone,
    safeTel
  } from "../../../lib/utils.js"
  export default {
    data() {
      return {
        fxfirstactivity:true,
        welcomeMask: false,
        bgasd: true,
        cards_id: '',
        loginedphone: '',
        peice: 0,
        param: {
          mobile: "",
          sms_code: ""
        },
        codeTxt: "获取验证码",
        loginstatus: 0,
        cardname: ''
      }
    },
    created() {
      this.getJsAuth()
      if (localStorage.getItem('token')) {
        this.loginstatus = 1
        this.getuserinfo()
      } else {
        this.loginstatus = 0
      }
    },
    mounted() {
      window.addEventListener('scroll', this.handleScroll, true);
    },
    methods: {

      tobuycardempty(){
        this.$toast('该卡已售罄');
      },
      toindex(){
        sessionStorage.setItem('index_scroll_top','yes')
        this.$router.push({
          path:'/'
        })
      },
      getJsAuth() {
        let that = this;
        var param = {
          url: location.href.split('#')[0]
        }
        var qs = require('qs');
        let url = this.api.userApi.getJsAuth
        this.axios.post(url, qs.stringify(param), )
        .then((res) => {
          // // // console.log(res)
          wx.config({
            debug: false,
            appId: res.data.appid, // 必填，公众号的唯一标识
            timestamp: res.data.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.data.noncestr, // 必填，生成签名的随机串
            signature: res.data.signature,
            jsApiList: [
              'getLocation',
              'updateAppMessageShareData', //自定义“分享给朋友”及“分享到QQ”按钮的分享内容（1.4.0） 新接口
              'updateTimelineShareData', //自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容（1.4.0） 老接口
              'onMenuShareTimeline', //分享到朋友圈 老接口
              'onMenuShareAppMessage', //分享给盆友 老接口
            ]
          });
          wx.ready(function() {
            that.sharecurr()
          });
        }).catch((error) => {
          console.warn(error)
          that.$toast(error);
        })


      },
      sharecurr(){
        let that = this
        const u = navigator.userAgent;
        const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        if (isiOS) {
          wx.updateAppMessageShareData({
            title: '斐燃生活超值购卡活动', // 分享标题
            desc: '星级酒店高端游泳、健身、瑜伽服务，会员预约仅需88元超低价', //分享描述
            link: window.location.href, // 分享链接
            imgUrl: 'http://img.unionfit.cn/feiran_logo.png', // 分享图标
            success(res) {
              // // console.log(res)
            }
          });
          wx.updateTimelineShareData({
            title: '斐燃生活超值购卡活动', // 分享标题
            link: window.location.href, // 分享链接
            imgUrl: 'http://img.unionfit.cn/feiran_logo.png', // 分享图标
            success(res) {
              // // console.log(res)
            }
          });
        } else {
          wx.onMenuShareAppMessage({
            title: '斐燃生活超值购卡活动', // 分享标题
            desc: '星级酒店高端游泳、健身、瑜伽服务，会员预约仅需88元超低价', //分享描述
            link: window.location.href, // 分享链接
            imgUrl: 'http://img.unionfit.cn/feiran_logo.png', // 分享图标
            success(res) {
              // // console.log(res)
            }
          });
          wx.onMenuShareTimeline({
            title: '斐燃生活超值购卡活动', // 分享标题
            link: window.location.href, // 分享链接
            imgUrl: 'http://img.unionfit.cn/feiran_logo.png', // 分享图标
            success(res) {
              // console.log(res)
            }
          });
        }

      },
      telasd(item){
        window.location.href="tel:400-630-5888"
      },
      handleScroll(){
        let hclientHeight = document.documentElement.clientHeight || document.body.clientHeight;
        // console.log('设备高度：'+hclientHeight)
        var anchor = this.$el.querySelector('#anchor')
        let scrollTop = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset
        // // console.log(anchor.offsetTop)
        // console.log(anchor.offsetTop)
        // console.log(scrollTop)
        // console.log(anchor.offsetTop - scrollTop)
        if(anchor.offsetTop - scrollTop>hclientHeight+40){
          this.fxfirstactivity=true
        }else{
          this.fxfirstactivity=false
        }
      },
      Anchorlocation() {
        let header = document.querySelector(".Anchorlocation")
        header.scrollIntoView({
          behavior: "smooth",
        })
      },
      getuserinfo() {
        var $this = this
        this.$loading('加载中');
        let param = {
          token: localStorage.getItem("token")
        }
        // getInfo
        var qs = require('qs');
        let url = this.api.userApi.getInfo
        this.axios.post(url, qs.stringify(param), )
        .then((result) => {
          // console.log(result)
          $this.$loading.close()
          if (result.data) {
            $this.loginedphone = safeTel(result.data.user.mobile)
          } else {
            this.$toast(result.msg)
          }
        }).catch((error) => {
          console.warn(error)
          $this.$loading.close()
          // $this.$toast('error');
        })
      },
      tobuycard(cards_id) {
        // console.log(cards_id)
        this.welcomeMask = true;
        this.cards_id = cards_id
        if (cards_id == 1003) {
          this.peice = 288
          this.cardname = '金卡'
        } else if (cards_id == 1002) {
          this.peice = 888
          this.cardname = '铂金卡'
        } else {
          this.peice = 2888
          this.cardname = '钻石卡'
        }
      },
      hidepanel() {
        this.welcomeMask = false
      },
      agress() {
        this.bgasd = false
      },
      agressno() {
        this.bgasd = true
      },
      toprotol() {
        this.$router.push({
          name: 'buycardprotocol'
        })
      },
      getSmsCaptcha() {
        let that = this;
        if (this.codeTxt == "获取验证码") {
          let param = {
            openid: localStorage.getItem("openid"),
            mobile: this.param.mobile
          }
          //
          var qs = require('qs');
          let url = this.api.userApi.getSmsCaptcha
          this.axios.post(url, qs.stringify(param), )
          .then((result) => {
            that.$toast(result.msg);
            if (result.code == 0) {
              that.codeTxt = "60s";
              let s = 60
              setInterval(function() {
                s -= 1;
                if (s > 0) {
                  that.codeTxt = s + "s";
                } else {
                  that.codeTxt = "获取验证码";
                }
              }, 1000)
            }
          }).catch((error) => {
            console.warn(error)
            that.$toast(error);
          })
        }
      },
      doLogin() {
        this.$loading('正在登陆')
        var $this = this
        if (!isPhone(this.param.mobile)) {
          this.$toast('请输入正确手机号')
          $this.$loading.close()
          return;
        }

        var source = localStorage.getItem("source")
        if (source == null || source == undefined || source == '') {
          this.param.source = '';
        } else {
          this.param.source = source;
        }
        this.param.openid = localStorage.getItem("openid");
        //
        var qs = require('qs');
        let url = this.api.userApi.getLogin
        this.axios.post(url, qs.stringify(this.param), )
        .then((result) => {
          console.log(result)
          if (result.data) {
            $this.$loading.close()
            sessionStorage.setItem('realName', 'yes')
            localStorage.setItem("token", result.data.token);
            // $this.$toast("登录成功");
            setTimeout(function() {
              $this.tishi()
            }, 200);
          } else {
            $this.$loading.close()
            $this.$toast(result.msg)
          }
        }).catch((error) => {
          console.warn(error)
          $this.$loading.close()
          // $this.$toast('error');
        })


      },
      tobCard() {
        if (localStorage.getItem('token')) {
          // console.log('已登录状态')
          // console.log(this.bgasd)
          if (this.bgasd == true) {
            this.$toast('请仔细阅读并同意《斐燃会员开通协议》')
          } else {
            this.tishi()
          }
        } else {
          // console.log('未登录状态')
          if (this.bgasd == true) {
            this.$toast('请仔细阅读并同意《斐燃会员开通协议》')
          } else {
            this.doLogin()
          }
        }
      },

      tishi() {
        var $this = this
        // // console.log('购卡')
        // // console.log(this.buycarinfo[this.icolistIndex].id)
        // console.log(this.cards_id)
        this.$router.push({
          name:'vip'
        })
        return
        if(this.cards_id==1003){
          this.$toast('该卡已售罄，请重新选择');
          return
        }
        let param = {
          token: localStorage.getItem("token"),
          cards_id: this.cards_id,

        }
        // console.log(param)
        $this.$loading('正在提交');
        //
        var qs = require('qs');
        // let url = this.api.userApi.buyCard
        let url = $this.api.userApi.bookBuyCards
        this.axios.post(url, qs.stringify(param), )
        .then((result) => {
          // console.log(result)
          if (!result.data) {
            $this.$toast(result.msg);
            $this.$loading.close()
          } else {
            if (result.data.pay_json) {
              let config = JSON.parse(result.data.pay_json);
              // // console.log(result)
              localStorage.setItem('dindanorder', result.data.order_no)
              if (typeof WeixinJSBridge == "undefined") {
                if (document.addEventListener) {
                  document.addEventListener('WeixinJSBridgeReady', $this.onBridgeReady(config), false);
                } else if (document.attachEvent) {
                  document.attachEvent('WeixinJSBridgeReady', $this.onBridgeReady(config));
                  document.attachEvent('onWeixinJSBridgeReady', $this.onBridgeReady(config));
                }
              } else {
                $this.onBridgeReady(config);
              }
            } else {
              $this.$loading.close()
              $this.$toast("开通成功");
              // 我的会员卡列表发生变化，vuex 更新我的会员卡
              var temp=[]
              $this.$store.commit('setMyCards',temp)
              // $this.$router.go(0)
              sessionStorage.setItem('index_scroll_top','yes')
              $this.$router.push({
                name: 'myCard'
              })
            }
          }
        }).catch((error) => {
          console.warn(error)
          $this.$loading.close()
          // $this.$toast('error');
        })


      },
      onBridgeReady(config) {
        let that = this;
        var $this = this
        WeixinJSBridge.invoke(
          'getBrandWCPayRequest', config,
          function(res) {
            if (res.err_msg == "get_brand_wcpay_request:ok") {
              $this.$loading.close()
              that.$toast("开通成功");
              // 我的会员卡列表发生变化，vuex 更新我的会员卡
              var temp=[]
              $this.$store.commit('setMyCards',temp)
              // that.$router.go(0)
              sessionStorage.setItem('index_scroll_top','yes')
              that.$router.push({
                name: 'myCard'
              })
            } else {
              $this.$loading.close()
              that.$toast("支付失败,请重新支付");
            }
          });
      },
    },
    beforeDestroy() {
      window.removeEventListener('scroll', this.handleScroll,true); //  离开页面清除（移除）滚轮滚动事件
    },
  }
</script>

<style lang="less" scoped="scoped">
  @vm_base: 1/750*100vw;
  .usernoncardstatusbtnsm{
    width: 300*@vm_base;
    height: 80*@vm_base;
    line-height: 80*@vm_base;
    text-align: center;
    color: #FFFFFF;
    background: #444054;
    font-size: 28*@vm_base;
    border-radius: 12*@vm_base;
    margin: 0 auto;
    margin-bottom: 44*@vm_base;
  }
  .welcome_img {
    width: 100%;
  }
  .welcomediv{
    position: relative;
    div{
      position: absolute;
      bottom: 0;
      right: 0;
      font-size: 28*@vm_base;
      color: #000000;
      // height: 64*@vm_base;
      // line-height: 64*@vm_base;
      text-align: center;
      padding: 8*@vm_base 32*@vm_base;
      margin-right: 82*@vm_base;
      border-radius: 45*@vm_base;
      border: 1px solid rgba(0,0,0,0.5);
    }
    .welcomediva{
      margin-bottom: -20*@vm_base;
    }
    .welcomediv_saleover{
      position: absolute;
      top: 0;
      left: 0;
      width: 96*@vm_base;
      margin-left: 93*@vm_base;
      margin-top: 125*@vm_base;
    }
  }
  .fx_firstactivityseat {
    height: 90*@vm_base;
  }

  .fx_firstactivity {
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 1;
    width: 100%;
    height: 90*@vm_base;
    line-height: 90*@vm_base;
    text-align: center;
    background: #232322;
    font-size: 32*@vm_base;
    font-weight: bold;
    color: #a79a7e;
    letter-spacing: 3px;
  }

  .welcome_mask {
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100%;
    z-index: 2;
    background: rgba(0, 0, 0, 0.7);
  }

  .welcome_cont {
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 3;
    background: #FFFFFF;
    border-radius: 15*@vm_base 15*@vm_base 0 0;

    .welcome_cont_panel {
      padding: 32*@vm_base 32*@vm_base 0 32*@vm_base;

      .welcome_cont_panel_type1 {
        width: 100%;

        .welcome_cont_panel_type1_title {
          font-weight: bold;
          font-size: 32*@vm_base;
          margin-top: 32*@vm_base;
        }

        .welcome_cont_panel_type1_logintitle {
          font-weight: normal;
          color: rgba(0, 0, 0, 0.5);
          font-size: 32*@vm_base;
          margin-top: 32*@vm_base;
        }

        .welcome_cont_panel_type1_panel {
          width: 100%;
          font-size: 32*@vm_base;
          padding: 12*@vm_base 0;
          border-bottom: 1*@vm_base solid #000000;
          margin-top: 24*@vm_base;

          .welcome_cont_panel_type1_panel_icon {
            display: block;
            width: 64*@vm_base;
            height: 64*@vm_base;
            background-image: url(../../../assets/images/activity/welcome/phone.png);
            background-size: 80%;
            background-position: center;
            background-repeat: no-repeat;
            float: left;
          }

          .welcome_cont_panel_type1_panel_iconcode {
            display: block;
            width: 64*@vm_base;
            height: 64*@vm_base;
            background-image: url(../../../assets/images/activity/welcome/code.png);
            background-size: 80%;
            background-position: center;
            background-repeat: no-repeat;
            float: left;
          }

          .welcome_cont_panel_type1_panel_p {
            width: calc(100% - 64*@vm_base);
            // height: 64*@vm_base;
            // background: red;
            float: left;

            .welcome_cont_panel_type1_panel_p_ph {
              width: 96*@vm_base;
              height: 64*@vm_base;
              float: left;
              line-height: 64*@vm_base;
              text-align: center;
              border-right: 1*@vm_base solid rgba(0, 0, 0, 0.7);
            }

            .welcome_cont_panel_type1_panel_p_on {
              width: calc(100% - 97*@vm_base);
              height: 64*@vm_base;
              // background: blue;
              float: left;

              input {
                width: calc(100% - 10*@vm_base);
                margin-left: 10*@vm_base;
                height: 64*@vm_base;
                border: none;
                outline: none;
              }
            }

          }

          .welcome_cont_panel_type1_panel_q {
            width: calc(100% - 64*@vm_base);
            // height: 64*@vm_base;
            padding-left: 10*@vm_base;
            float: left;

            .welcome_cont_panel_type1_panel_p_code {
              width: calc(100 - 156*@vm_base);
              height: 64*@vm_base;
              line-height: 64*@vm_base;
              float: left;
            }

            .welcome_cont_panel_type1_panel_p_codeSMS {
              width: 156*@vm_base;
              height: 64*@vm_base;
              line-height: 64*@vm_base;
              font-size: 24*@vm_base;
              text-align: center;
              float: right;
              white-space: nowrap;
            }
          }
        }
      }

      .welcome_cont_panel_typec {
        width: 100%;
        margin-top: 64*@vm_base;

        .welcome_cont_panel_type1_title {
          font-weight: bold;
          font-size: 32*@vm_base;
          margin-bottom: 32*@vm_base;
        }
        .welcome_cont_panel_type1_tit{
          width: calc(100% - 64*@vm_base);
          margin: 0 auto;
          margin-bottom: 96*@vm_base;
          position: relative;
          .welcome_cont_panel_type1_tit_img{
            width: 100%;
          }
          .welcome_cont_panel_type1_tit_img_saleover{
            position: absolute;
            top: 0;
            left: 0;
            width: 96*@vm_base;
          }
        }

        // img {}
      }
    }
  }

  .bb_vip_submit_protol {
    width: 100%;
    height: 72*@vm_base;
    line-height: 72*@vm_base;
    font-size: 24*@vm_base;
    color: #666666;

    .bb_vip_submit_protol_bg1 {
      display: inline-block;
      float: left;
      width: 38*@vm_base;
      height: 72*@vm_base;
      background-size: 28*@vm_base 28*@vm_base;
      background-repeat: no-repeat;
      background-position: center center;
      // background-image: url(../../src/assets/visionNew/assets/choose_agree_no.png);
      margin-left: 24*@vm_base;
      background-image: url(../../../assets/images/activity/welcome/choose_agree_yes.png);
    }
    .bb_vip_submit_protol_bg2 {
      display: inline-block;
      float: left;
      width: 38*@vm_base;
      height: 72*@vm_base;
      background-size: 28*@vm_base 28*@vm_base;
      background-repeat: no-repeat;
      background-position: center center;
      background-image: url(../../../assets/images/activity/welcome/choose_sport_no.png);
      margin-left: 24*@vm_base;
      // background-image: url(../../src/assets/visionNew/assets/choose_agree_yes.png);
    }

    .bb_vip_submit_protol_p {
      display: inline-block;
      float: left;
      // width: 38*@vm_base;
      height: 72*@vm_base;
    }

    .bb_vip_submit_protol_pro {
      display: inline-block;
      float: left;
      // width: 38*@vm_base;
      height: 72*@vm_base;
    }
  }

  .ClearBoth {
    clear: both;
  }

  .welcome_cont_btn {
    width: 100%;
    height: 90*@vm_base;
    position: relative;

    .welcome_cont_btnl {
      height: 90*@vm_base;
    }

    .welcome_cont_btnr {
      height: 90*@vm_base;
      position: absolute;
      top: 0;
      right: 0;
      z-index: 3;
    }

    .welcome_cont_price {
      width: 100%;
      height: 90*@vm_base;
      line-height: 90*@vm_base;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 4;
      padding: 0 32*@vm_base;
      color: #444054;
      font-size: 32*@vm_base;

      div {
        float: right;
        height: 90*@vm_base;
        line-height: 90*@vm_base;
        color: #FFFFFF;
        font-size: 32*@vm_base;
        font-weight: 500;
        margin-right: 22*@vm_base;
      }
    }
  }
  .welcome_img2{
    margin-bottom: 45*@vm_base;
  }
</style>



// WEBPACK FOOTER //
// src/components/activity/welcome/welcome.vue